import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ScannedAttendees from './ScannedAttendees';
import { fetchScannedAttendees, exportScannedAttendeesEmail, fetchAttendee, postFavorite, postAttendeeNotes } from '../../actions/api';
import { updateHeader, updateGlobal, updateFavModel } from '../../actions/local';
import { selectScannedAttendees, selectScannedAttendeesIds } from '../../selectors/scannedAttendees';
import { selectUser } from '../../selectors/user';
import { selectGlobal } from '../../selectors/global';
import { selectHeader } from '../../selectors/header';
import { selectMenuItems } from '../../selectors/menuItems';
import { selectCurrentEvent } from '../../selectors/events';
import { SEARCH_DELAY } from '../../constants/app';

class ScannedAttendeesContainer extends React.Component {
  componentDidMount() {
    // Set up header with search button
    this.props.updateHeader({
      leftBtn: 'back',
      rightBtn: 'search'
    });

    // Load data based on mode
    this.props.fetchScannedAttendees({ 
      reset: true,
      ...this.getSharedApiParams()
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.eventId !== prevProps.match.params.eventId) {
      this.props.fetchScannedAttendees({ 
        reset: true,
        ...this.getSharedApiParams()
      });
    }

    // Handle search value changes
    if (this.props.global.searchValue !== prevProps.global.searchValue) {
      this.searchScannedAttendees();
    }
  }

  searchScannedAttendees = () => {
    if (this.searchTimeout) {
      this.searchTimeout = clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.fetchScannedAttendees({ reset: true });
    }, SEARCH_DELAY);
  };

  fetchScannedAttendees = data => {
    this.props.fetchScannedAttendees({
      ...data,
      q: this.props.global.searchValue,
      ...this.getSharedApiParams()
    });
  };

  getSharedApiParams = () => {
    const { appId, eventId } = this.props.match.params;
    const params = {
      app_id: +appId,
      event_id: +eventId
    };
    return params;
  };

  postAttendeeNotes = (data) => {
    this.props.postAttendeeNotes({
      ...data,
      ...this.getSharedApiParams()
    });
  };

  resetExportEmailSuccess = () => {
    this.props.updateGlobal({ exportEmailSuccess: false });
  };

  render() {
    const propsWithApiData = {
      ...this.props,
      fetchScannedAttendees: this.fetchScannedAttendees,
      getSharedApiParams: this.getSharedApiParams,
      matchParams: this.props.match.params,
      menuItems: this.props.menuItems,
      postFavorite: this.props.postFavorite,
      postAttendeeNotes: this.postAttendeeNotes,
      updateFavModel: this.props.updateFavModel,
      resetExportEmailSuccess: this.resetExportEmailSuccess
    };

    return <ScannedAttendees {...propsWithApiData} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    scannedAttendees: selectScannedAttendees(state, ownProps),
    scannedAttendeesIds: selectScannedAttendeesIds(state, ownProps),
    user: selectUser(state, ownProps),
    global: selectGlobal(state, ownProps),
    header: selectHeader(state, ownProps),
    menuItems: selectMenuItems(state, ownProps),
    event: selectCurrentEvent(state, { eventId: ownProps.match.params.eventId }),
    hasMoreScannedAttendees: false,
    isLoadingScannedAttendees: false,
    presenceIds: state.global.presenceIds || [],
    exportEmailSuccess: state.global.exportEmailSuccess
  };
};

const mapDispatchToProps = {
  fetchScannedAttendees,
  exportScannedAttendeesEmail,
  fetchAttendee,
  postFavorite,
  postAttendeeNotes,
  updateHeader,
  updateGlobal,
  updateFavModel
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ScannedAttendeesContainer)));
